import NO_PRODUCT_FOUND from "./no-product-found.png"

export const Images={
    NO_PRODUCT_FOUND
}